import React, { useEffect, useRef } from 'react';

export const OutsideClick = (Component: React.ComponentType<any>) => {
  const WrappedComponent = (props: {
    onClickOutside: (event: MouseEvent) => void;
    className?: string;
    [key: string]: any;
  }) => {
    const { onClickOutside, className, ...restProps } = props;
    const wrapperRef = useRef<HTMLDivElement>(null);

    const handleClickOutside = React.useCallback(
      (event: MouseEvent) => {
        if (
          wrapperRef.current &&
          !wrapperRef.current.contains(event.target as Node)
        ) {
          onClickOutside(event);
        }
      },
      [onClickOutside]
    );

    useEffect(() => {
      document.addEventListener('click', handleClickOutside, false);
      return () => {
        document.removeEventListener('click', handleClickOutside, false);
      };
    }, [handleClickOutside]);

    return (
      <div
        className={className}
        style={{ position: 'absolute' }}
        ref={wrapperRef}
      >
        <Component {...restProps} />
      </div>
    );
  };

  WrappedComponent.displayName = `OutsideClick(${
    Component.displayName || Component.name || 'Component'
  })`;

  return WrappedComponent;
};
